import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface SelectOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html'
})

export class ConfirmDialogComponent implements OnInit {
  message: string = "";
  confirmButtonText = "";
  cancelButtonText = "";
  showCancelButton = true;
  showSelect = false;
  selectOptions: SelectOption[] = [];
  selectedValue: string = '';
  form: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      selectedOption: ['']
    });
  }

  ngOnInit() {
    if (this.data) {
      this.message = this.data.message || this.message;
      this.confirmButtonText = this.data.confirmButtonText ?? this.data.confirmText ?? "Sí";
      this.cancelButtonText = this.data.cancelButtonText ?? this.data.cancelText ?? "No";
      this.showCancelButton = this.data.showCancelButton ?? this.data.showCancel ?? true;
      
      // Configurar el selector si es necesario
      this.showSelect = this.data.showSelect || false;
      if (this.showSelect && this.data.selectOptions) {
        this.selectOptions = this.data.selectOptions;
      }
    } else {
      this.confirmButtonText = "Sí";
      this.cancelButtonText = "No";
      this.showCancelButton = true;
    }
  }

  onConfirmClick(): void {
    if (this.showSelect) {
      this.dialogRef.close({
        confirmed: true,
        selectedValue: this.form.get('selectedOption')?.value
      });
    } else {
      this.dialogRef.close(true);
    }
  }
}
